import React from "react";

function Index(props) {
  return (
    <>
      <div className="x_title">
        <h2>{props.title}</h2>
        <div className="clearfix"></div>
      </div>
    </>
  );
}
export default Index;
